module.exports = __webpack_public_path__ + "img/old_exp.ab17c75a.png";